<mat-spinner [color]="'accent'" [mode]="'indeterminate'"></mat-spinner>